<template>
    <rkm-area
        background-color="primary"
        title="Triagem de Risco Alimentar (TRIA)"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => formatBoolean(item.objetivo.tria.alimentosAcabaram)"
                    label="Nos últimos três meses, os alimentos acabaram antes que você tivesse dinheiro para comprar mais comida?"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => formatBoolean(item.objetivo.tria.comeuAlgunsAlimentos)"
                    label="Nos últimos três meses, você comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou?"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.objetivo.tria.dataAtualizacaoTria || 'Não informado'"
                    label="Data de atualização"
                />
            </rkm-col>
        </rkm-row>

    </rkm-area>
</template>

<script>
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
    methods: {
        formatBoolean(value) {
            if (value === true) {
                return 'Sim'
            }

            if (value === false) {
                return 'Não'
            }

            return 'Não informado'
        },
    },
}
</script>